import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getAllCourseListing = async () => {
    let response = null;
    let errorMessage = null;

    try {
        const res = await api.get.course.getAllList();

        const content = res.map((o) => ({ ...o, label: o.title, value: o.id }));

        response = { content };
    } catch (error) {
        errorMessage = serveRequestErrors(error);
    }

    if (response) return response;

    throw errorMessage;
};

export default getAllCourseListing;
